var exports = {
  "v": "x1cb7f6e3--f44ec2--loader-wrap",
};

module.exports = exports;
